// Copyright 2025, University of Maryland, All Rights Reserved
import { forwardRef } from 'react'
import { ReactFlowProvider } from '@xyflow/react'

import type {
  PipelineCanvasHandle,
  PipelineCanvasProps,
  PipelineConfigContext,
} from './canvas/PipelineCanvas'
import { PipelineCanvas } from './canvas/PipelineCanvas'

export type { PipelineCanvasHandle, PipelineCanvasProps, PipelineConfigContext }

export const PipelineBuilder = forwardRef<PipelineCanvasHandle, PipelineCanvasProps>((props, ref) => {
  return (
    <ReactFlowProvider>
      <PipelineCanvas ref={ref} {...props} />
    </ReactFlowProvider>
  )
})

PipelineBuilder.displayName = 'PipelineBuilder'
